<div id="shared-paginator-container" class="paginator-container">
  <div id="shared-paginator-content-container" class="paginator-content-container">
    <!-- THE CONTENT FROM THE PARENT COMPONENT -->
    <ng-content id="shared-paginator-content" select=".paginator-content"></ng-content>
  </div>

  <!-- PAGINATOR FOOTER TO NAVIGATE ACROSS THE PAGES -->
  <div id="shared-paginator-footer-container" class="paginator-footer-container">
    <div *ngIf="showItemsRange" id="shared-paginator-items-range">
      <app-text id="shared-paginator-page-number-text" textStyleType="body2">
        {{ start + 1 + '-' + end }} {{ 'pickProduct.of' | translate }}
        {{ totalRecords }}</app-text
      >
    </div>
    <!-- PAGINATOR BACK BUTTON -->
    <div
      id="shared-paginator-back-btn"
      [ngClass]="{ 'paginator-back-btn': true, 'icon-disabled': !isPreviousBtnEnabled() }"
    >
      <app-icon
        id="shared-paginator-back-btn-icon"
        [name]="'keyboard_arrow_left'"
        [size]="'1.5em'"
        (iconClicked)="onPreviousButtonClick()"
      ></app-icon>
    </div>

    <!-- PAGE NUMBER -->
    <div
      *ngIf="!showItemsRange"
      id="shared-paginator-page-number"
      class="paginator-page-number"
    >
      <app-text id="shared-paginator-page-number-text" textStyleType="mobile-overline">{{
        currentPageNumber + '/' + totalPages
      }}</app-text>
    </div>

    <!-- PAGINATOR NEXT BUTTON -->
    <div
      id="shared-paginator-next-btn"
      [ngClass]="{ 'paginator-next-btn': true, 'icon-disabled': !isNextBtnEnabled() }"
    >
      <app-icon
        id="shared-paginator-next-btn-icon"
        [name]="'keyboard_arrow_right'"
        [size]="'1.5em'"
        (iconClicked)="onNextButtonClick()"
      ></app-icon>
    </div>
  </div>
</div>
